// ============================================
// P3 支付线（P-08 前端）：全局支付弹窗宿主
// 挂载在 ProLayout / EditorLayout，消费 payIntent 全局意图
// ============================================
import { useEffect, useState } from 'react';
import PayDialog from './PayDialog';
import { usePayIntentStore } from './payIntent';
import { fetchPayStatus } from '../../api/pay';

export default function PayDialogHost() {
  const { open, input, onSuccess, closePay } = usePayIntentStore();
  const [mock, setMock] = useState(false);

  useEffect(() => {
    if (!open) return;
    fetchPayStatus().then((s) => setMock(s.mock)).catch(() => setMock(false));
  }, [open]);

  return (
    <PayDialog
      open={open}
      onClose={closePay}
      mock={mock}
      channelSwitchable
      orderInput={input}
      onSuccess={(order) => {
        onSuccess?.();
        closePay();
        void order;
      }}
    />
  );
}
